// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"eb7004cf","301":"67ebcf48","541":"b4171c96","571":"32cb25d8","612":"37d508ec","787":"12012e30","836":"c3f19b7f"}[chunkId] + ".chunk.js";
};